export default __webpack_public_path__ + "static/media/warning.ded5854a.svg";